import { gql } from '@apollo/client';

export const HASHES = gql`
  query hashes($args: HashesInput!) {
    hashes(args: $args) {
      pageInfo {
        totalCount
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          hash
          type
          hashType
          cracked
          numRounds
          filePath
          hashcatNumber
          correlations {
            assetName
            assetId
          }
        }
      }
    }
  }
`;
